module.exports = __webpack_public_path__ + "static/media/icon-illustration.142b4bba.svg";